export default __webpack_public_path__ + "static/media/goods12.f4b2ffd5.gif";